import update from 'immutability-helper';
// eslint-disable-next-line import/no-cycle
import {
  MARAPHONS_PROGRESS,
  MARAPHONS_SUCCESS,
  MARAPHONS_FAILED,
  MARAPHONS_GET_LIST_PROGRESS,
  MARAPHONS_GET_LIST_SUCCESS,
  MARAPHONS_GET_LIST_FAILED,
  MARAPHONS_FORM_SUBMIT_PROGRESS,
  MARAPHONS_FORM_SUBMIT_SUCCESS,
  MARAPHONS_FORM_SUBMIT_FAILED,
  MARAPHONS_GET_COURSE_PROGRESS,
  MARAPHONS_GET_COURSE_SUCCESS,
  MARAPHONS_GET_COURSE_FAILED,
  MARAPHONS_GET_ASYNC_DATA_PROGRESS,
  MARAPHONS_GET_ASYNC_DATA_SUCCESS,
  MARAPHONS_GET_ASYNC_DATA_FAILED,
  MARAPHONS_GET_ASYNC_FORM_DATA_PROGRESS,
  MARAPHONS_GET_ASYNC_FORM_DATA_SUCCESS,
  MARAPHONS_GET_ASYNC_FORM_DATA_FAILED,
  MARAPHONS_CLEAR_STATE,
  MARAPHONS_CLEAR_FLASH_MESSAGE,
} from '../actions/maraphonsAction';

const initialState = {
  loadListStatus: '', // progress/success/failed
  loadActiveStatus: '', // progress/success/failed
  submitStatus: '', // progress/success/failed
  formDataStatus: '', // progress/success/failed
  asyncStatus: '', // progress/success/failed
  list: [],
  pagination: {},
  active: {},
  asyncData: {},
  flash: '',
};

export default function (state = initialState, action) {
  switch (action.type) {
    case MARAPHONS_GET_LIST_PROGRESS: {
      return update(state, {
        list: { $set: [] },
        pagination: { $set: {} },
        loadListStatus: { $set: MARAPHONS_PROGRESS },
      });
    }
    case MARAPHONS_GET_LIST_SUCCESS: {
      return update(state, {
        list: { $set: action.payload.list },
        pagination: { $set: action.payload.pagination },
        loadListStatus: { $set: MARAPHONS_SUCCESS },
      });
    }
    case MARAPHONS_GET_LIST_FAILED: {
      return update(state, {
        list: { $set: [] },
        pagination: { $set: {} },
        loadListStatus: { $set: MARAPHONS_FAILED },
      });
    }
    case MARAPHONS_FORM_SUBMIT_PROGRESS: {
      return update(state, { submitStatus: { $set: MARAPHONS_PROGRESS } });
    }
    case MARAPHONS_FORM_SUBMIT_SUCCESS: {
      return update(state, {
        flash: { $set: action.payload },
        submitStatus: { $set: MARAPHONS_SUCCESS },
      });
    }
    case MARAPHONS_FORM_SUBMIT_FAILED: {
      return update(state, { submitStatus: { $set: MARAPHONS_FAILED } });
    }
    case MARAPHONS_GET_COURSE_PROGRESS: {
      return update(state, {
        active: { $set: {} },
        loadActiveStatus: { $set: MARAPHONS_PROGRESS },
      });
    }
    case MARAPHONS_GET_COURSE_SUCCESS: {
      return update(state, {
        active: { $set: action.payload.maraphon },
        loadActiveStatus: { $set: MARAPHONS_SUCCESS },
      });
    }
    case MARAPHONS_GET_COURSE_FAILED: {
      return update(state, {
        active: { $set: {} },
        loadActiveStatus: { $set: MARAPHONS_FAILED },
      });
    }
    case MARAPHONS_GET_ASYNC_DATA_PROGRESS: {
      return update(state, {
        asyncData: { $set: {} },
        asyncStatus: { $set: MARAPHONS_PROGRESS },
      });
    }
    case MARAPHONS_GET_ASYNC_DATA_SUCCESS: {
      return update(state, {
        asyncData: { $set: action.payload },
        asyncStatus: { $set: MARAPHONS_SUCCESS },
      });
    }
    case MARAPHONS_GET_ASYNC_DATA_FAILED: {
      return update(state, {
        asyncData: { $set: {} },
        asyncStatus: { $set: MARAPHONS_FAILED },
      });
    }
    case MARAPHONS_GET_ASYNC_FORM_DATA_PROGRESS: {
      return update(state, {
        asyncData: { $set: {} },
        formDataStatus: { $set: MARAPHONS_PROGRESS },
      });
    }
    case MARAPHONS_GET_ASYNC_FORM_DATA_SUCCESS: {
      return update(state, {
        asyncData: { $set: action.payload },
        formDataStatus: { $set: MARAPHONS_SUCCESS },
      });
    }
    case MARAPHONS_GET_ASYNC_FORM_DATA_FAILED: {
      return update(state, {
        asyncData: { $set: {} },
        formDataStatus: { $set: MARAPHONS_FAILED },
      });
    }
    case MARAPHONS_CLEAR_STATE: {
      return update(state, {
        loadListStatus: { $set: '' },
        loadActiveStatus: { $set: '' },
        submitStatus: { $set: '' },
        formDataStatus: { $set: '' },
        asyncStatus: { $set: '' },
        list: { $set: [] },
        pagination: { $set: {} },
        active: { $set: {} },
        asyncData: { $set: {} },
      });
    }
    case MARAPHONS_CLEAR_FLASH_MESSAGE: {
      return update(state, {
        flash: { $set: '' },
      });
    }
    default:
      return state;
  }
}
